module.exports = __webpack_public_path__ + "static/media/heart-svgrepo-com (7).a527f8a0.svg";